'use client';

import { createContext, useContext } from 'react';

const DatadogReadyContext = createContext(false);

export const DatadogReadyProvider = DatadogReadyContext.Provider;

export function useDatadogReady() {
  return useContext(DatadogReadyContext);
}
